import { useState, useEffect } from "react";
import { MoonIcon, SunIcon } from "@heroicons/react/24/solid";

const ThemeToggle = () => {
  const [isMounted, setIsMounted] = useState(false);
  // const [isDarkMode, setIsDarkMode] = useState(() => {
  //   if (typeof window !== "undefined") {
  //     return localStorage.getItem("theme") === "dark";
  //   }
  //   return false;
  // });

  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem("theme");

      // If user has already chosen a theme, use it
      if (savedTheme) {
        return savedTheme === "dark";
      }

      // Default theme
      return true;
    }

    return true;
  });

  useEffect(() => {
    setIsMounted(true);
    const body = document.body;

    if (isDarkMode) {
      body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      body.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  if (!isMounted) return null;

  return (
    <button
      onClick={toggleTheme}
      aria-label="Toggle dark mode"
      className="p-1 sm:p-2 rounded-full border border-gray-300 dark:border-gray-600 
             bg-gray-100 dark:bg-gray-800 
             hover:bg-gray-200 dark:hover:bg-gray-900 
             focus:bg-blue-200 dark:focus:bg-blue-700 
             focus:border-blue-400 dark:focus:border-blue-500 
             text-gray-800 dark:text-gray-100 
             transition-all duration-200 hover:scale-110 hover:shadow outline-none"
    >
      {isDarkMode ? (
        <SunIcon className="w-5 h-5" />
      ) : (
        <MoonIcon className="w-5 h-5" />
      )}
    </button>
  );
};

export default ThemeToggle;
